import React, { useEffect, useMemo, useState } from 'react';
import { Button } from 'react-bootstrap';
import { quizMcAnswerImageUrlsFromKey } from '../utils/quizMcAnswerImageSrc';

export interface McImageAnswerButtonProps {
  basePath: string;
  imageAssetKey: string;
  variant: string;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
  showCorrectIcon?: boolean;
  /** Fallback when image file is missing */
  fallbackLabel: string;
}

const McImageAnswerButton: React.FC<McImageAnswerButtonProps> = ({
  basePath,
  imageAssetKey,
  variant,
  className = '',
  disabled = false,
  onClick,
  showCorrectIcon = false,
  fallbackLabel,
}) => {
  const urls = useMemo(
    () => quizMcAnswerImageUrlsFromKey(basePath, imageAssetKey),
    [basePath, imageAssetKey]
  );
  const [ext, setExt] = useState<'webp' | 'png'>('webp');
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    setExt('webp');
    setImgFailed(false);
  }, [urls?.webp, urls?.png, imageAssetKey]);

  const useImage = urls && !imgFailed;

  return (
    <Button
      type="button"
      variant={variant}
      className={`answer-button mc-image-answer-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {showCorrectIcon && !useImage ? (
        <i className="bi bi-check-circle-fill me-2" aria-hidden />
      ) : null}
      {useImage ? (
        <span className="mc-image-answer-button__img-wrap">
          <img
            src={ext === 'webp' ? urls.webp : urls.png}
            alt=""
            className="mc-image-answer-button__img"
            decoding="async"
            onError={() => {
              if (ext === 'webp') setExt('png');
              else setImgFailed(true);
            }}
          />
        </span>
      ) : (
        fallbackLabel
      )}
    </Button>
  );
};

export default McImageAnswerButton;
